import { styled, Typography } from '@mui/material';

import { taskPriorityColors } from 'features/postDetails/components/PostDetails/styled';
import { TaskPriority } from 'types';

export const TaskW = styled('div')<{ isPreview: boolean }>(({ theme, isPreview }) => ({
  width: '100%',
  minHeight: isPreview ? '160px' : 'auto',
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: theme.palette.white.main,
  border: `1px solid ${theme.palette.primary.grey}`,
  position: 'relative',
  cursor: 'pointer',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',

  [theme.breakpoints.down('desktop')]: {
    width: isPreview ? '100%' : 'auto',
  },
}));

export const TitleW = styled(Typography, {
  shouldForwardProp: (propname) => propname !== 'isPreview',
})<{ isPreview: boolean }>(({ theme, isPreview }) => ({
  fontSize: isPreview ? '14px' : '16px',
  lineHeight: isPreview ? '20px' : '22px',
  fontWeight: 700,
  color: theme.palette.primary.p080,
  wordBreak: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
}));

export const DescriptionW = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p050};
  overflow: hidden;

  & p {
    margin: 0;

    &:has(code) {
      margin: 4px 0;
    }
  }

  & a {
    color: ${({ theme }) => theme.palette.info.main};
    z-index: 9999;
  }

  & h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 0;
    font-size: inherit;
  }
`;

export const ProgressBarContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
`;

export const ProgressTrack = styled('div')`
  flex: 1;
  height: 4px;
  background: ${({ theme }) => theme.palette.primary.p010 ?? 'rgba(0, 0, 0, 0.08)'};
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressFill = styled('div')<{ value: number }>(({ theme, value }) => ({
  height: '100%',
  width: `${value}%`,
  background: theme.palette.info.main,
  borderRadius: '2px',
  transition: 'width 0.3s ease',
}));

export const ProgressLabel = styled(Typography)`
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.p050};
  min-width: 32px;
  text-align: right;
  flex-shrink: 0;
`;

export const FooterW = styled('div')<{ isPreview: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: auto;
  padding-top: 4px;
`;

export const FooterLeftW = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const DividerW = styled('div')`
  height: 1px;
  background: ${({ theme }) => theme.palette.primary.p010 ?? 'rgba(0, 0, 0, 0.06)'};
`;

export const DateContainer = styled('div')`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.white.main};
  gap: 8px;
`;

export const DateW = styled(Typography)`
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const AvatarW = styled('div')`
  flex-shrink: 0;
  margin-left: 8px;
  min-width: 104px;
`;

export const IconW = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CountW = styled(Typography)`
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const HeaderLeftW = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const ProfileHeaderW = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ProfileHeaderContentW = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const PriorityChip = styled(Typography)<{ priority: TaskPriority }>(({ priority }) => {
  const background = taskPriorityColors[priority] ?? '#D5BDFF';
  return {
    height: '36px',
    width: '66px',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
    padding: '8px',
    borderRadius: '4px',
    backgroundColor: background,
    textTransform: 'capitalize',
    flexShrink: 0,
    textAlign: 'center',
  };
});
